/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: e86a911c (Thu May 21 20:23:17 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface ExpireTeamMemberRequestParams
 */
export interface ExpireTeamMemberRequestParams {
  /**
   * The unique identifier of the actor to be expired.
   * @type number
   * @memberof ExpireTeamMemberRequestParams
   */
  actorKey: number
}

export function ExpireTeamMemberRequestParamsFromJSON(
  json: any
): ExpireTeamMemberRequestParams {
  return ExpireTeamMemberRequestParamsFromJSONTyped(json, false)
}

export function ExpireTeamMemberRequestParamsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExpireTeamMemberRequestParams {
  if (json === undefined || json === null) {
    return json
  }
  return {
    actorKey: json['actorKey'],
  }
}

export function ExpireTeamMemberRequestParamsToJSON(
  value?: ExpireTeamMemberRequestParams | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    actorKey: value.actorKey,
  }
}
